const convertToSnakeCase = (value: string = '') => {
  return value.replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('_');
};

export {
  convertToSnakeCase
};
